import React, { useCallback } from 'react';
import { defineMessages, useIntl } from 'react-intl';
import { useDispatch } from 'react-redux';
import AssessmentActions from 'components/checkIn/questionnaire/AssessmentActions';
import { loadCheckInStatus } from 'redux/checkIn/sagas';

const PromptToReload = () => {
  const dispatch = useDispatch();
  const reload = useCallback(() => dispatch(loadCheckInStatus()), [dispatch]);
  const copy = useCopy();

  return <AssessmentActions blurb={copy.blurb} buttonText={copy.buttonText} onClick={reload} />;
};
export default PromptToReload;

const useCopy = () => {
  const copy = defineMessages({
    loadingFailureBlurb: {
      id: 'check-in.loading-failure.blurb',
      defaultMessage: 'Failed to load the survey',
    },
    retryButtonCaption: {
      id: 'check-in.loading-failure.button-caption',
      defaultMessage: 'Retry',
    },
  });

  const intl = useIntl();
  const blurb = intl.formatMessage(copy.loadingFailureBlurb);
  const buttonText = intl.formatMessage(copy.retryButtonCaption);

  return { blurb, buttonText };
};
